import { render, staticRenderFns } from "./InterfaceSettings.vue?vue&type=template&id=2e089a01"
import script from "./InterfaceSettings.vue?vue&type=script&lang=js"
export * from "./InterfaceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports